import { ActionType } from "../../../react-core/Flux/ActionType";
import { BaseStore } from "../../../react-core/Flux/BaseStore";
import { TreasuredAssetsDispatcher } from "./Variable";

export interface TreasuredAssetsStoreStaticState {
    isLoading?: boolean;
    actionType: ActionType;
    treasuredAssetsProductIds?: Array<number>;
}

export class TreasuredAssetsStoreStatic extends BaseStore<TreasuredAssetsStoreStaticState> {
    constructor() {
        super();
        this.subscribeToDispatcher(TreasuredAssetsDispatcher, (actionData) =>
            this.onTreasuredAssetsStoreResponse(actionData)
        );
    }

    public getLastResult(): TreasuredAssetsStoreStaticState {
        return this.getState();
    }

    public isLoading(): boolean {
        return this.getState().isLoading;
    }

    public getActionType() {
        return this.getState().actionType;
    }

    protected getDefaultState(): TreasuredAssetsStoreStaticState {
        return { actionType: ActionType.Loading };
    }

    public getTreasuredAssetsProductIds(): Array<number> {
        return this.getState().treasuredAssetsProductIds;
    }

    private onTreasuredAssetsStoreResponse(actionData): void {
        switch (actionData.actionType) {
            case ActionType.Success:
                this.setState({
                    actionType: actionData.actionType,
                    isLoading: false,
                    treasuredAssetsProductIds: actionData.payload,
                });
                break;
            case ActionType.Error:
            case ActionType.Loading:
                this.setState({ actionType: actionData.actionType });
                break;
        }
    }
}
